import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';

import type { AppRouteContext } from '../../../app/routeContext';
import type { AppRole } from '../rbac';
import { hasAnyRole } from '../rbac';

type RequireRoleProps = {
  allowed: readonly AppRole[];
  children?: ReactNode;
  fallbackPath?: string;
};

export default function RequireRole({
  allowed,
  children,
  fallbackPath = '/forbidden'
}: RequireRoleProps) {
  const location = useLocation();
  const context = useOutletContext<AppRouteContext>();

  if (!hasAnyRole(context.core.currentUser?.role, allowed)) {
    return <Navigate to={fallbackPath} replace state={{ from: location.pathname }} />;
  }

  return children ? <>{children}</> : <Outlet context={context} />;
}
